<template>
    <el-container direction="vertical">
        <el-row class="expense-production-header">
            <el-col :xs="24" :sm="24" :md="24" :lg="16">
                <div class="expense-production-subtitle">
                    ID {{ expense.id }} (создан {{ expense.created_by_name }} {{ expense.created_at }})
                </div>
                <div class="expense-production-title">
                    Создать расходы на производство
                </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="8" class="actions">
                <template>
                    <template v-if="isEdit">
                        <span class="action-title action-edit" @click="save">
                            Сохранить
                        </span>
                    </template>
                    <template v-else>
                        <span class="action-title action-edit">
                            Редактировать
                        </span>
                    </template>
                </template>
                <span class="action-title action-close" @click="close">
                    Закрыть
                </span>
            </el-col>
        </el-row>
        <div class="expense-production-main">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="24" :lg="5" class="print-custom-width-1">
                    <el-row>
                        <el-col :span="9" class="gray">
                            Дата расхода
                        </el-col>
                        <el-col :span="15">
                            <el-date-picker
                                v-model="expense.date"
                                type="date"
                                placeholder="дд.мм.гггг"
                                format="dd.MM.yyyy"
                                value-format="dd.MM.yyyy"
                                :picker-options="pickerOptions"
                                :clearable="false"
                                size="mini"
                                class="w100"
                            />
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="9" class="gray">
                            Касса
                        </el-col>
                        <el-col :span="15">
                            <el-select
                                v-model="expense.office_id"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                collapse-tags
                                clearable
                                autocomplete
                                size="mini"
                            >
                                <el-option v-for="item in officeList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="9" class="gray">
                            &nbsp;
                        </el-col>
                        <el-col :span="15">
                            <el-select
                                v-model="expense.pay_type_id"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                collapse-tags
                                clearable
                                autocomplete
                                size="mini"
                            >
                                <el-option v-for="item in payTypesList" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="9" class="gray">
                            Сумма, руб
                        </el-col>
                        <el-col :span="15">
                            <auto-numeric
                                v-model="expense.amount"
                                :options="numericOptions"
                                class="autonumeric"
                            />
                            <div class="field-error bold" v-if="errors.amount" v-text="errors.amount[0]"></div>
                            <div v-else-if="!isExpenseAmountEqDealExpenseAmount && deals.length" class="field-error bold">
                                {{ amountErrorMessage }}
                            </div>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="11" class="print-custom-width-2">
                    <el-row>
                        <el-col :span="10" class="gray">
                            Отчётный период
                        </el-col>
                        <el-col :span="14" class="period-select">
                            <div class="filter-label">
                                Год
                            </div>
                            <el-select
                                v-model="expense.period_year"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                placeholder="Год"
                                size="mini"
                                class="period-select-year"
                            >
                                <el-option v-for="item in localReferences.yearsList" :key="item" :label="item" :value="item" />
                            </el-select>
                            <div class="filter-label">
                                Месяц
                            </div>
                            <el-select
                                v-model="expense.period_month"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                clearable
                                placeholder="Месяц"
                                size="mini"
                                class="period-select-month"
                            >
                                <el-option v-for="item in localReferences.monthsList" :key="item" :label="item" :value="item" />
                            </el-select>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="10" class="gray">
                            Статья
                        </el-col>
                        <el-col :span="14">
                            {{ getExpenseType }}
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="10" class="gray">
                            Получил - тип
                        </el-col>
                        <el-col :span="14">
                            {{ receivedByType }}
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="10" class="gray">
                            Получил
                        </el-col>
                        <el-col :span="14">
                            <el-select
                                v-model="expense.recipient_id"
                                placement="bottom"
                                popper-class="popper-dropdown"
                                filterable
                                collapse-tags
                                clearable
                                autocomplete
                                size="mini"
                            >
                                <el-option v-for="item in receivedByIdListForFilter" :key="item.id" :label="item.name" :value="item.id" />
                            </el-select>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :xs="24" :sm="24" :md="24" :lg="8" class="print-custom-width-3">
                    <el-row>
                        <el-col class="gray pt10">
                            Комментарий
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col>
                            <template v-if="isEdit">
                                <el-input
                                    size="mini"
                                    type="textarea"
                                    :autosize="{ minRows: 2, maxRows: 4}"
                                    placeholder=""
                                    v-model="expense.comment"
                                />
                                <div class="error" v-if="errors.comment">
                                    {{ errors.comment[0] }}
                                </div>
                            </template>
                            <template v-else>
                                <div v-format-text="expense.comment">
                                </div>
                            </template>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </div>
        <template>
            <div class="expense-production-deals" v-show="isDealsVisible">
                <div class="expense-production-deals-grid" v-loading="loadingDeals">
                    <template v-for="(column, index) in dealsColumns">
                        <div :key="'header_' + index" class="header-cell">
                            {{ column.headerName }}
                        </div>
                    </template>
                    <template v-for="(deal, dealIndex) in deals">
                        <template v-for="(column, columnIndex) in dealsColumns">
                            <div
                                :key="dealIndex+ '_'+ columnIndex"
                                :class="column.fieldClass"
                                :title="column.field === 'contract' || column.field === 'address' ? deal[column.field] : false"
                            >
                                <template v-if="column.field === 'debt_paid'">
                                    <el-checkbox v-model="deal[column.field]" @change="handleDebtPaid(deal)" />
                                </template>
                                <template v-else-if="column.field === 'deal_id'">
                                    <a :href="getDealLink(deal[column.field])" target="_blank" class="link">
                                        {{ deal[column.field] }}
                                    </a>
                                </template>
                                <template v-else-if="column.field === 'expense_sum' ">
                                    <auto-numeric
                                        v-model="deal[column.field]"
                                        :options="[numericOptions, getNumericOptionsForDeal(deal)]"
                                        class="autonumeric"
                                    />
                                </template>
                                <template v-else-if="column.field === 'sum'">
                                    <div>{{ deal[column.field]['production_cost'] ? formatFinance(deal[column.field]['production_cost']) : '-' }}</div>
                                    <div>{{ deal[column.field]['expense_sum_production'] ? formatFinance(deal[column.field]['expense_sum_production']) : '-' }}</div>
                                </template>
                                <template v-else>
                                    {{ deal[column.field] }}
                                </template>
                            </div>
                        </template>
                    </template>
                </div>
                <div
                    :class="[
                        'debts-total',
                        { 'green bold': isExpenseAmountEqDealExpenseAmount },
                        { 'red bold': !isExpenseAmountEqDealExpenseAmount }
                    ]"
                    v-if="deals.length"
                >
                    Сумма к перечислению: {{ formatFinance(expensesTotalAmount) }} руб.
                </div>
            </div>
        </template>
    </el-container>
</template>
<script>
import ExpenseMixin from '@/mixins/expense';
import moment from 'moment';
import '@/assets/styles/card.scss';
import '@/assets/styles/expenses-production.scss?1';
import { pickerOptions } from '@/common/pickerOptions';
import { formatFinance } from '@/common/utilities';
import '@/assets/styles/print.scss?1';
import localReferences from '@/helpers/localReferences';

const initialExpensesProduction = {
    id: null,
    created_at: moment().format('DD.MM.YYYY HH:mm'),
    created_by_name: '',
    period_month: '',
    period_year: '',
    period: [],
    report_date: '',
    office_id: '',
    pay_type_id: '',
    amount: '',
    recipient_id: '',
    recipient_type: 'factory',
    source_type: 'cash',
    date: '',
    comment: '',
    expense_type: 'production'
};

export default {
    name: 'ExpensesProductionBaseGrid',
    mixins: [
        ExpenseMixin
    ],
    data() {
        return {
            expense: { ...initialExpensesProduction },
            errors: [],
            deals: [],
            dealsList: [],
            contactDebt: null,
            contactDeal: null,
            loadingMain: false,
            loadingDeals: false,
            numericMinimumValue: '-9999999999999',
            isEdit: 1,
            formLabelWidth: '120px',
            pickerOptions,
            selectedRowsCount: 0,
            dealsColumns: [
                { headerName: 'Id сделки', field: 'id', fieldClass: 'grid-cell' },
                { headerName: 'Дата замера', field: 'measurement_date', fieldClass: 'grid-cell' },
                { headerName: 'Дата монтажа', field: 'installation_date', fieldClass: 'grid-cell' },
                { headerName: 'Дата запуска в производство', field: 'start_production_date', fieldClass: 'grid-cell' },
                { headerName: 'Договор № от', field: 'contract', fieldClass: 'grid-cell cut-text' },
                { headerName: 'Адрес', field: 'address', fieldClass: 'grid-cell cut-text' },
                { headerName: 'м2', field: 'square_m2', fieldClass: 'grid-cell' },
                { headerName: 'Сумма в производство', field: 'sum', fieldClass: 'grid-cell' },
                { headerName: 'Долг погашен', field: 'debt_paid', fieldClass: 'grid-cell' },
                { headerName: 'Сумма расхода', field: 'expense_sum', fieldClass: 'grid-cell' }
            ],
            pageModel: {
                currentPage: 1,
                pageSize: 20
            },
            amountErrorMessage: 'Сумма расхода по сделкам не совпадает с суммой к перечислению'
        };
    },
    methods: {
        formatFinance,
        handlePositionClick(position) {
            position.isOpened = !position.isOpened;
        },
        async getDeals(period, recipientId) {
            this.loadingDeals = true;
            try {
                this.deals = [];
                this.deals = await this.$store.dispatch('expenses/getDealsProduction', { period: period, recipient_id: recipientId });
            } catch (error) {
                console.log(error.message);
            } finally {
                this.loadingDeals = false;
            }
        },
        save() {
            if (!this.expense.amount || !parseInt(this.expensesTotalAmount, 10)) {
                return;
            }
            if (this.isSaveButtonPressed) {
                return;
            }
            this.isSaveButtonPressed = true;
            if (this.deals.length) {
                if (this.isExpenseAmountEqDealExpenseAmount) {
                    this.createDealProductionExpenses();
                } else {
                    this.errors = { amount: [this.amountErrorMessage] };
                    this.$message({
                        showClose: true,
                        message: this.amountErrorMessage,
                        type: 'error',
                        duration: 5000,
                        customClass: this.alertClass()
                    });
                    this.isSaveButtonPressed = false;
                }
            }
        },
        async createDealProductionExpenses() {
            const expenses = this.deals.filter(deal => deal.expense_sum > 0).map(deal => {
                return {
                    date: this.expense.date,
                    report_date: this.getPeriod(),
                    created_by_id: this.$store.state.auth.employerId,
                    source_type: localReferences.expenseSource.cash,
                    office_id: this.expense.office_id,
                    pay_type_id: this.expense.pay_type_id,
                    recipient_type: this.expense.recipient_type,
                    recipient_id: this.expense.recipient_id,
                    deal_id: deal.id,
                    amount: deal.expense_sum,
                    comment: this.expense.comment,
                    expense_detail: [{
                        expense_type: this.expense.expense_type,
                        amount: deal.expense_sum
                    }]
                };
            });

            this.loadingDeals = true;
            try {
                const response = await this.$store.dispatch('expenses/createDealProductionExpenses', { expenses });
                const totalAmount = response.data.data.meta.totalAmount;
                const expensesCount = response.data.data.data.length;

                if (totalAmount) {
                    this.showMessage(`Создано ${expensesCount} операций расход на сумму ${totalAmount} руб.`);
                }
                this.expense.amount = 0;
                this.getDeals(this.getPeriod(), this.expense.recipient_id);
            } catch (e) {
                console.log(e.message);
            } finally {
                this.loadingDeals = false;
                this.isSaveButtonPressed = false;
            }
        },
        close() {
            this.$router.go(-1);
        },
        getCurrentPage(page) {
            this.pageModel.currentPage = page;
        },
        handleDebtPaid(deal) {
            deal.expense_sum = deal.debt_paid ? deal.sum.production_cost - deal.sum.expense_sum_production : 0;
        },
        getPeriod() {
            if (this.expense.period_month.length > 0 && this.expense.period_year) {
                return '01.' + this.expense.period_month + '.' + this.expense.period_year;
            }
        },
        dealHandler() {
            this.deals = [];
            if (this.issetPeriod && this.expense.recipient_id) {
                this.getDeals(this.getPeriod(), this.expense.recipient_id);
            }
        },
        expense_sum() {
            return this.deal.expense_sum;
        },
        showMessage(message) {
            this.$notify({ title: 'Успешно', message, type: 'success' });
        },
        getNumericOptionsForDeal(deal) {
            return {
                readOnly: deal.debt_paid,
                maximumValue: (deal.sum.production_cost > 0 || deal.sum.expense_sum_production > 0) ? deal.sum.production_cost - deal.sum.expense_sum_production : 9999999,
                minimumValue: 0
            };
        }
    },
    beforeMount() {
        this.expense.recipient_type = 'factory';
        this.expense.period_year = new Date().getFullYear();
        this.expense.recipient_id = 1;
    },
    computed: {
        receivedByIdListForFilter() {
            return this.factoriesList;
        },
        pagesInfo() {
            return this.$store.state.deals.pages;
        },
        isSetPageSize20() {
            return this.pageModel.pageSize === 20;
        },
        isSetPageSize50() {
            return this.pageModel.pageSize === 50;
        },
        isSetPageSize100() {
            return this.pageModel.pageSize === 100;
        },
        isDealsVisible() {
            return this.issetPeriod && this.expense.recipient_id;
        },
        expensesTotalAmount() {
            return this.deals.reduce((sum, deal) => sum + +deal.expense_sum, 0);
        },
        isExpenseAmountEqDealExpenseAmount() {
            if (this.deals.length && this.expensesTotalAmount > 0) {
                return this.expense.amount === parseInt(this.expensesTotalAmount, 10);
            }
            return true;
        },
        period_month() {
            return this.expense.period_month;
        },
        period_year() {
            return this.expense.period_year;
        },
        issetPeriod() {
            return this.expense.period_month.length > 0 && this.expense.period_year;
        },
        recipient_id() {
            return this.expense.recipient_id;
        },
        receivedByType() {
            return this.getNameFromListById(this.receivedFromTypesList, this.expense.recipient_type);
        },
        getExpenseType() {
            return this.getNameFromListById(this.expenseTypeList, this.expense.expense_type);
        },
        amount() {
            return this.expense.amount;
        }
    },
    watch: {
        period_month() {
            this.dealHandler();
        },
        period_year() {
            this.dealHandler();
        },
        recipient_id() {
            this.dealHandler();
        }
    }
};
</script>
